import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-magic-line c-magic-line--underline"
}
const _hoisted_2 = {
  key: 1,
  class: "c-magic-line c-magic-line--underline"
}

import useBooleanToggle from '@/shared/useBooleanToggle';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandButton',
  props: {
    expandLabel: null,
    collapseLabel: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({(e: 'click', isToggled: boolean);}), expose: any, slots: any, attrs: any }) {





const { isToggled, toggle } = useBooleanToggle();

function onToggle() {
    toggle();
    emit('click', isToggled.value);
}

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "text-dusty-grey text-12 sm:text-14",
    onClick: onToggle
  }, [
    (_unref(isToggled))
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.collapseLabel), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.expandLabel), 1)),
    _createVNode(_component_c_icon, {
      class: _normalizeClass(["w-5 ml-8 rotate-90 transition-transform", {'rotate-270': _unref(isToggled)}]),
      name: "icon-arrow-medium"
    }, null, 8, ["class"])
  ]))
}
}

})